module.exports = __webpack_public_path__ + "img/320-d8b0f5.png";